<template>
  <div>
    <navbar-component></navbar-component>
    <main>
      <page-header title="Electrical Engineering"
                   :links="[{title:'Home', url:'/'},{title:'News Events'}]"></page-header>
      <div class="container-2">
        <section class="sidebar">
          <sidebar :active="12"></sidebar>
        </section>
        <section class="content">
          <div class="heading-black1">News & Events</div>
          <TabView>
            <tab-panel header="News">
              <activity-component v-for="news in newsList" :key="news" :activity="news"></activity-component>
            </tab-panel>
            <tab-panel header="Events">
              <activity-component v-for="event in events" :key="event" :activity="event"></activity-component>
            </tab-panel>
          </TabView>
        </section>
      </div>
      <key-recruiters></key-recruiters>
    </main>
    <footer-component></footer-component>
  </div>
</template>
<script>
import NavbarComponent from "@/components/Navbar.vue";
import FooterComponent from "@/components/Footer.vue";
import PageHeader from "@/components/PageHeader";
import Sidebar from "@/views/academics/electrical/Sidebar";
import TabView from "primevue/tabview";
import TabPanel from "primevue/tabpanel";
import ActivityComponent from "@/components/ActivityComponent";
import KeyRecruiters from "@/components/KeyRecruiters";

export default {
  name: "News_Events",
  components: {
    NavbarComponent,
    PageHeader,
    Sidebar,
    FooterComponent,
    TabView, TabPanel,
    ActivityComponent,
    KeyRecruiters
  },
  setup() {
    const carouselSlides = ["bg-1", "bg-2", "bg-3"];
    return {carouselSlides};
  },
  data() {
    return {
      newsList: [
        {
          name: "एसएनडी अभियांत्रिकीच्या विद्यार्थ्यांची कॅम्पस प्लेसमेंट मधुन निवड",
          date: "31 July 2021",
          details: "",
          images: [
            {
              "itemImageSrc": "/static/images/electrical/new-event/31-7-21.jpg",
              "thumbnailImageSrc": "",
              "alt": "campus image",
              "title": "campus image"
            },
          ]
        },
        {
          name: "एसएनडी अभियांत्रिकीच्या विद्यार्थ्यांची कॅम्पस प्लेसमेंट मधुन निवड",
          date: "25 July 2021",
          details: "",
          images: [
            {
              "itemImageSrc": "/static/images/electrical/new-event/25-7-21.jpg",
              "thumbnailImageSrc": "",
              "alt": "campus image",
              "title": "campus image"
            },
          ]
        },
        {
          name: "एसएनडी अभियांत्रिकीच्या ६ विद्यार्थ्यांची निवड",
          date: "8 Jan 2021",
          details: "",
          images: [
            {
              "itemImageSrc": "/static/images/electrical/new-event/Mahadiscom_8-10-21.jpg",
              "thumbnailImageSrc": "",
              "alt": "campus image",
              "title": "campus image"
            },
          ]
        },
        {
          name: "अभियांत्रिकी  विद्यार्थ्यांचा  उत्कृष्ट भरारी आणि सांस्कृतिक कार्यक्रम ",
          date: "2021",
          details: "",
          images: [
            {
              "itemImageSrc": "/static/images/electrical/new-event/news/24.jpg",
              "thumbnailImageSrc": "",
              "alt": "campus image",
              "title": "campus image"
            },
          ]
        },
        {
          name: "भारत फोर्जे मध्ये ३४ विद्यार्थ्यांची निवड ",
          date: "2021",
          details: "",
          images: [
            {
              "itemImageSrc": "/static/images/electrical/new-event/news/Bharat-forge2-768x683.jpg",
              "thumbnailImageSrc": "",
              "alt": "campus image",
              "title": "campus image"
            },
          ]
        },
        {
          name: "एसएनडीच्या २४ विद्यार्थ्यांची भरारी प्राचार्य डॉ. पी एम पाटील यांच्या पुढाकाराने कॅम्पस प्लेसमेंटमध्ये निवड ",
          date: "2021",
          details: "",
          images: [
            {
              "itemImageSrc": "/static/images/electrical/new-event/news/Placement-News3.jpg",
              "thumbnailImageSrc": "",
              "alt": "campus image",
              "title": "campus image"
            },
          ]
        },
        {
          name: "एसएनडी अभियांत्रिकी महाविद्यालय व संशोधन केंद्राला आय.एस.ओ ९००१:२०१५ चे मानांकन ",
          date: "2021",
          details: "",
          images: [
            {
              "itemImageSrc": "/static/images/electrical/new-event/news/ISO.jpg",
              "thumbnailImageSrc": "",
              "alt": "campus image",
              "title": "campus image"
            },
          ]
        },
        {
          name: "एसएनडी अभियांत्रिकी महाविद्यालयामध्ये १० विद्यार्थ्यांची कॅम्पस प्लेसमेंटमध्ये निवड",
          date: "2021",
          details: "",
          images: [
            {
              "itemImageSrc": "/static/images/electrical/new-event/news/Qspider.jpg",
              "thumbnailImageSrc": "",
              "alt": "campus image",
              "title": "campus image"
            },
          ]
        },
      ],
      events: [
        {
          name: "गुरू पूर्णिमा:गुरू ब्रह्मा गुरू विष्णु, गुरु देवो महेश्वरा गुरु साक्षात परब्रह्म, तस्मै श्री गुरुवे नमः",
          date: "",
          details: "",
          images: [
            {
              "itemImageSrc": "/static/images/electrical/new-event/news/GuruPornima.jpg",
              "thumbnailImageSrc": "",
              "alt": "campus image",
              "title": "campus image"
            },
          ]
        },
        {
          name: "एसएनडी अभियांत्रिकी महाविद्यालयात वृक्षारोपण कार्यक्रम संपन्न ",
          date: "",
          details: "",
          images: [
            {
              "itemImageSrc": "/static/images/electrical/new-event/news/Tree Plantation.jpg",
              "thumbnailImageSrc": "",
              "alt": "Description for Image 1",
              "title": "Title 1"
            },
          ]
        }
      ]
    }
  }
}
</script>
<style lang="scss" scoped/>
